// // YouTube API スクリプトを追加
// const tag = document.createElement('script');
// tag.src = 'https://www.youtube.com/iframe_api';
// tag.async = true;
// document.head.appendChild(tag);

// // グローバル関数として定義
// window.onYouTubeIframeAPIReady = function() {
//   console.log("YouTube API Ready!");
//   for (let i = 0; i < youtubeData.length; i++) {
//     embedYoutube(i);
//   }
// };

function whenYouTubeReady(callback) {
  let done = false;
  const run = () => {
    if (done || !(window.YT && window.YT.Player)) return;
    done = true;
    callback();
  };

  if (window.YT && window.YT.Player) {
    run();
    return;
  }

  const previous = window.onYouTubeIframeAPIReady;
  window.onYouTubeIframeAPIReady = function () {
    if (typeof previous === 'function') previous();
    run();
  };

  if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }

  const startedAt = Date.now();
  const timer = window.setInterval(() => {
    if (window.YT && window.YT.Player) {
      window.clearInterval(timer);
      run();
    } else if (Date.now() - startedAt > 10000) {
      window.clearInterval(timer);
    }
  }, 200);
}

whenYouTubeReady(() => {
  document.querySelectorAll('.pg-campany .yt-video[data-youtube-id]').forEach((embedArea) => {
    if (embedArea.closest('.pg-intro--company')) return;
    embedYoutube(embedArea);
  });
});

function bindAboutUsEmbed() {
  document.querySelectorAll('.pg-intro--company .pg-mov').forEach((mov) => {
    const poster = mov.querySelector('.js-yt-playbtn');
    const slot = mov.querySelector('.yt-video[data-youtube-id]');
    if (!poster || !slot) return;
    const img = poster.querySelector('img');
    if (img) {
      img.draggable = false;
      img.addEventListener('dragstart', (event) => event.preventDefault());
    }
    poster.addEventListener('click', () => {
      if (mov.dataset.embedStarted === '1') return;
      const id = slot.dataset.youtubeId;
      if (!id) return;
      mov.dataset.embedStarted = '1';
      poster.remove();
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&mute=1&controls=1&playsinline=1&rel=0';
      frame.title = 'About us';
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      slot.replaceWith(frame);
    });
  });
}

bindAboutUsEmbed();

const animationSpinning = {
  fadeOut: [{ opacity: 1 }, { opacity: 0.5 }, { opacity: 0 }],
  fadeIn: [{ opacity: 0 }, { opacity: 0.5 }, { opacity: 1 }],
};

const animationTiming = { duration: 600 };

function embedYoutube(embedArea) {
  if (!embedArea.dataset.youtubeId) return;

  const mov = embedArea.closest('.pg-mov');
  const playBtn = mov ? mov.querySelector('.js-yt-playbtn') : null;

  new YT.Player(embedArea, {
    videoId: embedArea.dataset.youtubeId,
    events: {
      'onReady': (event) => onPlayerReady(event, playBtn),
      'onStateChange': (event) => onPlayerFix(event, playBtn),
    },
    playerVars: {
      autoplay: 0,
      controls: 1,
      rel: 0,
      playsinline: 1,
    },
  });
}

function revealPlayer(playBtn) {
  if (!playBtn) return;
  playBtn.style.pointerEvents = 'none';
  playBtn.classList.add('is-dismissed');
  playBtn.animate(animationSpinning.fadeOut, animationTiming);
  window.setTimeout(() => {
    playBtn.style.display = 'none';
  }, animationTiming.duration);
}

function onPlayerReady(event, playBtn) {
  const frame = event.target.getIframe && event.target.getIframe();
  if (frame) {
    frame.style.position = 'absolute';
    frame.style.inset = '0';
    frame.style.width = '100%';
    frame.style.height = '100%';
    frame.style.pointerEvents = 'auto';
    frame.style.touchAction = 'auto';
  }
  if (!playBtn || playBtn.closest('.pg-intro--company')) return;

  playBtn.addEventListener('click', () => {
    revealPlayer(playBtn);
    event.target.mute();
    event.target.playVideo();
  });
}

function onPlayerFix(event, playBtn) {
  if (!playBtn || event.data !== YT.PlayerState.ENDED) return;
  event.target.seekTo(0, true);
  event.target.stopVideo();
  playBtn.classList.remove('is-dismissed');
  playBtn.style.pointerEvents = '';
  playBtn.style.visibility = '';
  playBtn.removeAttribute('aria-hidden');
  const img = playBtn.querySelector('img');
  if (img) img.style.pointerEvents = '';
  playBtn.animate(animationSpinning.fadeIn, animationTiming);
  playBtn.style.display = 'block';
}
